import axios from "axios";
import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { Table } from "react-bootstrap";
import { Link } from "react-router-dom";
import Pagination from "../../../components/Pagination/Pagination";
import AffiliateModal from "../Affiliate/AffiliateModal";

const AffiliatePaymentForCourse = ({ date, month, year }) => {
  const [affiliateData, setAffiliateData] = useState([]);
  const [allAffiliateData, setAllAffiliateData] = useState([]);
  const [affiliateModal, setAffiliateModal] = useState(false);
  const [refetch, setRefetch] = useState(false);
  const [modalData, setModalData] = useState("");

  useEffect(() => {
    const data = async () => {
      await axios
        .get("https://backend.studyswiftly.com/api/v1/affilate")
        .then((res) => {
          setAllAffiliateData(res.data.Categories);
        });
    };
    data();
  }, [refetch]);

  useEffect(() => {
    if (date !== "date" && month !== "month" && year !== "year") {
      const filteredByFullDate = allAffiliateData.filter((eachPayment) => {
        return (
          new Date(eachPayment?.createdAt)?.toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
          }) == `${date + "/" + month + "/" + year}`
        );
      });
      setAffiliateData(filteredByFullDate);
    } else if (month !== "month" && year !== "year") {
      console.log("Month, Year",new Date()?.toLocaleDateString("en-GB", {
        month: "2-digit",
        year: "numeric",
      }));
      const filteredByMonthAndYear = allAffiliateData.filter((eachPayment) => {
        return (
          new Date(eachPayment?.createdAt)?.toLocaleDateString("en-GB", {
            month: "2-digit",
            year: "numeric",
          }) === `${month + "/" + year}`
        );
      });
      setAffiliateData(filteredByMonthAndYear);
    } else if (year !== "year") {
    
      const filteredByYear = allAffiliateData.filter((eachPayment) => {
        return (
          new Date(eachPayment?.createdAt)?.toLocaleDateString("en-GB", {
            year: "numeric",
          }) === year
        );
      });
      setAffiliateData(filteredByYear);
    } else {
      setAffiliateData(allAffiliateData);
    }
  }, [date, month, year]);

  // Pagination
  const [pageNumber, setPageNumber] = useState(1);
  const [show, setShow] = useState(10);
  const [lastPage, setLastPage] = useState(0);
  const [sliceAffiliateData, setSliceAffiliateData] = useState([]);
  // console.log(sliceProducts)

  useEffect(() => {
    const lastPage = Math.ceil(affiliateData?.length / show);
    setLastPage(lastPage);
  }, [affiliateData, show]);

  useEffect(() => {
    if (pageNumber) {
      const page = parseInt(pageNumber);
      const getSlicingProduct = affiliateData.slice(
        (page - 1) * show,
        page * show
      );
      setSliceAffiliateData([...getSlicingProduct]);
      setPageNumber(parseInt(page));
    } else {
      const getSlicingProduct = affiliateData.slice(0, show);
      setSliceAffiliateData([...getSlicingProduct]);
    }
  }, [affiliateData, show, pageNumber]);

  const pageHandle = (jump) => {
    // navigate(`/admin/products/${jump}`);
    setPageNumber(parseInt(jump));
  };

  const handleModal = (data) => {
    // console.log(data)
    setModalData(data);
  };

  return (
    // <div className='adminBody' style={{ height: "100vh" }}>
    <div className="adminBody">
      <div className="adminCard py-2">
        <div className="tableNormal pt-5">
          <Table className="text-white adminDataTable">
            <thead>
              <tr>
                <th className="text-start ">Date</th>
                <th className="text-start">Student Email</th>
                <th className="text-start "> Amount</th>
              </tr>
            </thead>
            <tbody>
              {sliceAffiliateData?.map((data) => (
                <tr className="tableRow" key={data._id}>
                  <td align="text-start">{data.date}</td>
                  <td className="text-start">{data?.toEmail}</td>
                  <td className="text-start ">
                    <span style={{ color: "orange" }}>{data?.amount}</span> BUSD
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>

          {sliceAffiliateData?.length > 0 && (
            <div>
              <Pagination
                lastPage={lastPage}
                page={pageNumber}
                pageHandle={pageHandle}
              />
            </div>
          )}
        </div>
      </div>
      <AffiliateModal
        // affiliateModal={affiliateModal}
        // setAffiliateModal={setAffiliateModal}
        // refetch={refetch}
        // setRefetch={setRefetch}
        // modalData={modalData}
        // setModalData={setModalData}
        show={affiliateModal}
        refetch={refetch}
        setRefetch={setRefetch}
        setAffiliateModal={setAffiliateModal}
        onHide={() => setAffiliateModal(false)}
        modalData={modalData}
      />
    </div>
  );
};

export default AffiliatePaymentForCourse;
